import { createContext, use } from 'react';

export const BlockchainCurrentRoundNumberContext = createContext<bigint | null>(
  null
);

export const useBlockchainCurrentRoundNumber = () =>
  use(BlockchainCurrentRoundNumberContext);
